<template>
  <div class="subscribers-wrap">
    <template v-if="!isLoadingData && (getTenants.length < 1)">
      <div class="no-results text-center">No Subscribers detected!</div>
    </template>
    <template v-else>
      <div>
        <v-expansion-panels
            popout
            multiple
            focusable
            active-class="active"
        >
          <v-expansion-panel
              v-for="(subItem, subIndex) in getTenants"
              :key="`channel-type-tenant-key-${subIndex}`"
              text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
              title="Item"
          >
            <v-expansion-panel-header class="list-root"
                                      :title="`${subItem.subscribers.length > 0 ? subItem.subscribers.length : 'no'} subscribers`">
              <div class="channel-type-tenant-header" :style="{ opacity: subItem.subscribers.length < 1 ? 0.5 : 1 }">
                <v-icon small class="mr-2">fas fa-user</v-icon>
                {{ subItem.name }}
                <subscriber-count v-if="subItem.subscribers.length > 0" :count="subItem.subscribers.length"/>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-if="!!subItem.subscribers && (subItem.subscribers.length>0)">
                <subscriber-entry
                    v-for="subscriberItem in subItem.subscribers"
                    :key="`subscriber-entry-key-${subscriberItem.id}`"
                    :subscriber="subscriberItem"
                    action-edit
                    @delete="deleteChannelConfirmation"
                    @edit="showSubscriberEditorHandler"
                />
              </template>
              <template v-else>
                <div class="no-results">
                  no subscribers detected
                </div>
              </template>
              <div
                  class="add-subscription-clickable"
                  :class="$vuetify.theme.dark ? 'dark':'light'"
                  @click="addSubscriberHandler({text: subItem.name, value: subItem.id})"
              >
                + add
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </template>
    <div
        class="add-subscriber-clickable"
        :class="$vuetify.theme.dark ? 'dark':'light'"
        @click="showSubscriberEditorHandler(null)"
    >
      + add
    </div>
    <subscriber-editor
        :show="showEditor"
        :saving="saving"
        :subscriber="selectedSubscriber"
        :tenantsList="getTenants"
        :preselected-tenant="preselectedTenant"
        :channel-type-tenant-list="channelTypeTenantList"
        :channelTypes="getChannelTypes"
        @close="closeEditorHandler"
        @save="saveChannel"
    />
    <v-dialog
        v-model="showConfirmation"
        v-if="!!deleteChannelData && !!deleteChannelData.channel && !!deleteChannelData.channel.description"
    >
      <v-card class="confirmation-card">
        <v-card-title>
          {{ `Delete Channel "${deleteChannelData.channel.description}"` }}
        </v-card-title>
        <v-card-text v-if="deleteChannelData.affectedSubscriptionGroups.length>0" class="mt-2">
          <div>
            <v-icon x-small class="mb-1 mr-1" color="amber">fas fa-exclamation-triangle</v-icon>
            Can not delete this Channel. This channel is already assigned to the subscription groups:
          </div>
          <div>
            <ul>
              <li
                  v-for="(groupItem) in deleteChannelData.affectedSubscriptionGroups"
                  :key="`affected-subscription-group-key-${groupItem.id}`"
              >
                {{ `${groupItem.tenant.name} - ${groupItem.name}` }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelChannelDeletionHandler">Cancel</v-btn>
          <v-btn
              color="error"
              :disabled="deleteChannelData.affectedSubscriptionGroups.length>0"
              @click="deleteChannel"
          >Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {NotificationService} from "@/services/ApiService";
import SubscriberEntry from "@/components/Settings/Notifications/SubscriberEntry.vue";
import SubscriberCount from "@/components/Settings/Notifications/SubscriberCount.vue";
import SubscriberEditor from "@/components/Settings/Notifications/SubscriberEditor.vue";
import {cloneDeep} from "lodash";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'Subscribers',
  components: {SubscriberEditor, SubscriberEntry, SubscriberCount},
  data: () => ({
    loading: true,
    saving: false,
    channelTypeTenantList: [],
    // augmentedTenants: [],
    preselectedTenant: null,
    showEditor: false,
    showConfirmation: false,
    selectedSubscriber: null,
    deleteChannelData: {
      channel: null,
      affectedSubscriptionGroups: []
    },
  }),
  computed: {
    ...mapGetters("notifications", [
      "getTenants",
      "getChannels",
      "getChannelTypes",
      "isLoadingData",
      "getSubscriptionGroups"
    ]),
    // augmentedTenants() {
    //
    // }
  },
  // mounted() {
  //   // this.fetchChannelTypeTenant();
  //   this.prepareData();
  // },
  methods: {
    ...mapActions("notifications", ["prepareData"]),
    /**
     * handle the subscriber editor dialog panel show
     * @param subscriberData {Object} - the subscriber data to edit (optional. If null, the editor opens in create mode
     * @returns {Promise<void>}
     */
    async showSubscriberEditorHandler(subscriberData) {
      // console.log('opening editor', subscriberData);
      if (!!subscriberData) {
        this.selectedSubscriber = await cloneDeep(subscriberData);
        this.channelTypeTenantList.forEach(channelTypeTenantItem => {
          if (channelTypeTenantItem.id === subscriberData.channelTypeTenant) {
            const targetTenantId = channelTypeTenantItem.tenant_id;
            // console.log('targetTenantId for EDIT!!!!', targetTenantId);
            this.getTenants.forEach(tenantItem => {
              if (tenantItem.id === targetTenantId) {
                this.selectedSubscriber.tenant = {
                  id: tenantItem.id,
                  name: tenantItem.name
                };
              }
            })
          }
        })
      }
      this.showEditor = true;
    },

    /**
     * Close the subscriber editor and reset subscriber selection
     */
    closeEditorHandler() {
      this.showEditor = false;
      this.selectedSubscriber = null;
    },

    /**
     * Handle the add new subscriber action under an existing tenant as specified
     * by the data argument
     * @param tenantData {Object} - the preselectedTenant required data ({text: String, value: Number})
     */
    addSubscriberHandler(tenantData) {
      // console.log('tenantData in addSubscriberHandler', tenantData);
      this.preselectedTenant = {...tenantData};
      this.showEditor = true;
    },

    /**
     * save the subscriber/channel changes or create a new one based on below defined edit mode
     * @param channelData {Object} - The channel data to save
     * @returns {Promise<void>}
     */
    async saveChannel(channelData) {
      // console.log('channelData', channelData);
      let editMode = !!this.selectedSubscriber && !!channelData.id && (channelData.id.length > 0);
      this.saving = true;
      try {
        if (editMode === true) {
          await NotificationService.Channels.put(channelData);
        } else {
          await NotificationService.Channels.post(channelData);
        }
        this.$notifier.success(`Channel "${channelData.description}" ${editMode ? 'updated' : 'created'} successfully.`);
        await this.prepareData();
        this.showEditor = false;
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Failed to ${editMode ? 'update' : 'create'} Channel "${channelData.description}".`);
      }
      this.saving = false;
    },

    /**
     * Show a confirmation dialog before deleting a channel and warn user
     * about any potential Subscription Groups that will be affected and have the
     * targeted channel also removed from, in a cascade manner
     * @param channelData {Object} - The channel to be deleted relevant data
     */
    deleteChannelConfirmation(channelData) {
      // console.log('DELETE CHANNEL confirmation!!', channelData);
      let affectedGroups = [];
      this.getSubscriptionGroups.forEach(subscriptionGroupItem => {
        if (!!subscriptionGroupItem.channels && subscriptionGroupItem.channels.length > 0) {
          subscriptionGroupItem.channels.forEach(subscriptionGroupChannelItem => {
            if (subscriptionGroupChannelItem.id === channelData.id) {
              affectedGroups.push(subscriptionGroupItem);
            }
          });
        }
      });
      // console.log('affectedGroups', affectedGroups);
      this.deleteChannelData.channel = {...channelData};
      this.deleteChannelData.affectedSubscriptionGroups = affectedGroups;
      this.showConfirmation = true;
    },

    /**
     * Handle the canceling of the channel deletion
     * - close the delete channel confirmation dialog
     * - reset the deleteChannelData property
     */
    cancelChannelDeletionHandler() {
      this.showConfirmation = false;
      this.deleteChannelData = {
        channel: null,
        affectedSubscriptionGroups: []
      };
    },

    /**
     * Deletes the channel as specified by its ID after confirmation
     * by the user
     * @returns {Promise<void>}
     */
    async deleteChannel() {
      if (this.deleteChannelData.affectedSubscriptionGroups.length > 0) return;
      try {
        await NotificationService.Channels.deleteChannel(this.deleteChannelData.channel.id);
        this.$notifier.success(`Channel "${this.deleteChannelData.channel.description}" deleted successfully.`);
        this.showConfirmation = false;
        await this.prepareData();
      } catch (error) {
        console.error(error);
        this.$notifier.error(`Failed to delete Channel "${this.deleteChannelData.channel.description}".`);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subscribers-wrap {
  width: 100%;
  max-width: 752px;
  //padding: 4px 8px;

  .list-root {
    border: 1px solid #1c6e59;
    margin-bottom: 8px;
  }

  .active {
    & > .list-root {
      border: 2px solid #685AA1;

      &::before {
        background-color: rgb(102, 89, 157) !important;
      }
    }
  }


  .channel-type-tenant-header {
    display: flex;
    flex-flow: row;
    column-gap: 2px;
    align-items: center;
  }
}

.add-subscriber-clickable {
  text-align: center;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity ease-in-out 0.3s;
  //max-width: calc(100% - 32px);
  width: 100%;
  max-width: 720px;
  padding: 4px 8px;
  border-radius: 6px;
  background-color: #383c40;
  margin: 16px auto;

  &.dark {
    background-color: #383c40;
    box-shadow: 1px 0 4px rgba(0, 0, 0, 0.5);
  }

  &.light {
    background-color: #dbdbdb;
    box-shadow: 1px 0 2px rgba(0, 0, 0, 0.2);
  }

  &:hover {
    opacity: 1;
  }
}

.add-subscription-clickable {
  text-align: center;
  opacity: 0.7;
  cursor: pointer;
  transition: opacity ease-in-out 0.3s;
  width: 100%;
  max-width: 720px;
  padding: 4px 8px;
  border-radius: 6px;
  background-color: #383c40;

  &.dark {
    background-color: #383c40;
    box-shadow: 1px 0 4px rgba(0, 0, 0, 0.5)
  }

  &.light {
    background-color: #dbdbdb;
    box-shadow: 1px 0 2px rgba(0, 0, 0, 0.2);
  }

  &:hover {
    opacity: 1;
  }
}

.confirmation-card {
  max-width: 512px;
  margin: 0 auto;
}

.no-results {
  padding: 8px 16px !important;
}
</style>